var map = {
	"./qrcode2.png": 498,
	"./qrcode4.png": 5716,
	"./qrcode5.png": 6845,
	"./qrcode6.png": 1958,
	"./qrcode7.png": 975,
	"./qrcode8.png": 3496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8833;